import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  fetchClasses,
  UPDATE_NOTIFICATION_SUCCESS_MESSAGE,
  notificationsPath,
  updateNotification,
  fetchNotification,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import NotificationForm from "../../../templates/manager/NotificationForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export const EditNotification = (props: {
  match: { params: { id: string } };
}) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const id = parseInt(props.match.params.id, 10);
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === UPDATE_NOTIFICATION_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(notificationsPath);
    }
  }, [history, dispatch, state.success_message]);

  const updateNotificationFunc = React.useCallback(
    (notification: {
      id: number;
      content: string;
      for_teacher: boolean;
      class_ids: number[];
    }) => {
      dispatch(peep(updateNotification(notification)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    dispatch(fetchNotification(id));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, id, currentYear]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.notifications, to: notificationsPath }]}
        currentTitle={titles.editNotification}
      />
      {state.notification?.id === id && (
        <NotificationForm
          title={titles.editNotification}
          calling={calling}
          error={state.error}
          notification={state.notification}
          classes={state.classes}
          upsertNotification={updateNotificationFunc}
        />
      )}
    </div>
  );
};

export default EditNotification;
